import { isArray } from 'lodash'
import { CustomFile } from './File'

type OrdoclicMessageType =
  | 'all-batch-created'
  | 'batch-created'
  | 'close-iframe'
  | 'patient-selected'

type OrdoclicMessage = OrdoclicApiLightMessage | OrdoclicApiLightMessage[]

export interface OrdoclicApiLightBatchedPrescription {
  id: string
  isPrescription: boolean
}

export interface OrdoclicApiLightMessage {
  batch: OrdoclicApiLightBatchedPrescription[]
  patientId: string
}

export interface OrdoclicApiResponse {
  type: OrdoclicMessageType
  message: OrdoclicMessage
}

export interface OrdoclicPrescriptionFile {
  files: CustomFile[]
  patientId: number
}

export const isMultiPrescriptionsMessage = (
  ordoclicMessage: OrdoclicMessage,
): ordoclicMessage is OrdoclicApiLightMessage[] => isArray(ordoclicMessage)
